export default {
  '404': {
    meta: '404 page not found',
    heading: '404 - Page not found',
    content: 'Page you were looking is not found. If you think the webpage should be here please notify us using contact form in the footer.',
  },
  '500': {
    meta: 'Server error',
    heading: 'Something went wrong.',
    content: 'This should not have happened. If the error message persists please contact us using the contact form below.',
  },
  magidShiur: {
    table: {
      filterByMasechta: 'Filter By Masechta',
    },
  },
  otherShiurim: {},
  magidShiurTorah: {},
  homepage: {
    featuredMagidShiur: 'Featured Shiurim',
  },
  torahShiurSingle: {
    noteOnShiur: 'Notes On This Shiur',
    moreShiurimBy: 'More Shiurim By',
  },
  videoPage: {
    suggestedShiur: 'Suggested Shiurim by Speaker',
  },
  category: {
    heading: '{{ name }} Shiurim',
  },
  approbations: {
    meta: 'APPROBATIONS הסכמות',
    heading: 'Haskamos',
  },
  resources: {
    meta: 'Daf Resources',
    heading: 'Torah Resources',
  },
  about: {
    meta: 'About us',
  },
  contact: {
    meta: 'Contact us',
    address: '25 Olympia Lane, Waterbury, Connecticut 06704',
    address1: '25 Olympia Lane, Waterbury',
    state: 'Connecticut 06704',
    hotlineHeading: 'Hotline Number',
    hotline: '610-206-1100',
    phone: '203-312-SHAS (7427)',
    phoneLink: '203-312-SHAS',
    email: 'info@shasilluminated.org',
    sendMessage: 'Send us a message',
  },
  rss: {
    meta: 'RSS Feeds and podcasts.',
    title: 'RSS FEED',
    content: 'You can subscribe to our main feed to receive daily daf or subscribe to each masechta separately.',
    heading: 'Main Feed',
  },
  donate: {
    donationType: 'Donation Type',
    oneTime: 'One Time',
    selectBillingCycle: 'Select Billing Cycle',
    untilNotice: 'Until notice',
    donationAmount: 'Donation Amount',
    selectAmount: 'Please select a donation amount.',
    yourDonation: 'Your donation',
    personalInfo: 'Personal information',
    enterFullname: 'Please enter your fullname',
    enterEmail: 'Please enter valid email',
    enterAddress1: 'Please enter Address 1 field',
    enterCity: 'Please enter city.',
    enterZip: 'Please enter ZIP / Postal code.',
    enterState: 'Please enter state.',
    enterCountry: 'Please select country.',
    sendReciept: 'Send me a paper receipt, in addition to email receipt.',
    addDedication: 'Add a Dedication',
    inMemory: 'In Memory Of',
    inHonor: 'In Honor Of',
    nameOfLovedOne: 'Name of Loved one',
    additionalInfo: 'Additional dedication information i.e. specific day/daf dedicated...',
    paymentMethod: 'Payment Method',
    duration: {
      monthly: 'Monthly',
      monthlyUntil: 'Monthly Until Notice',
      monthly1Month: 'Monthly 1 Month',
      monthlyForXMonths: 'Monthly for {{ count }} Months',
    },
    successCard: {
      heading: 'Thank you for your donation',
      content: 'We sent you and e-mail with donation details.',
    },
  },
  live: {
    heading: 'Live Streams',
  },
  profile: {
    greeting: 'Hello {{ name }}, you are logged in as {{ email }}.',
  },
};
